<template>
  <div class="common-home-entrance">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>网站设置</BreadcrumbItem>
          <BreadcrumbItem>快捷入口</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">快捷入口</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="add()">
          <span>添加快捷入口</span>
        </div>
      </div>
    </div>

    <div class="content">
      <Table :border="false" :columns="columns1" :data="list" :disabled-hover="false" no-data-text="暂无数据">
        <template slot-scope="{ row, index }" slot="name">{{row.name}}</template>
        <template slot-scope="{ row, index }" slot="description">{{row.description}}</template>
        <template slot-scope="{ row, index }" slot="linkName">{{row.linkName}}</template>
        <template slot-scope="{ row, index }" slot="link">{{row.link}}</template>
        <template slot-scope="{ row, index }" slot="showIndex">{{row.showIndex}}</template>
        <template slot-scope="{ row, index }" slot="action">
          <span style="color: #1890ff;cursor: pointer;margin-right:10px;" @click="editModal(row)">编辑</span>
          <!-- <span style="display: inline-block;padding: 0 5px;">|</span> -->
          <Poptip confirm title="确认是否删除?" @on-ok="delItem(row)" :transfer="true">
            <span style="color: #f00;cursor: pointer;">删除</span>
          </Poptip>
        </template>
      </Table>
    </div>

    <commonEntranceAdd 
      :show="showModel"
      :modelTitle="modelTitle"
      :options="options"
      @finish="init()"
      @close="showModel=false;"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import commonEntranceAdd from "../components/web-entrance-add.vue";

export default {
  name: "host-common-ad",
  data() {
    return {
      showModel: false,
      columns1: [
        {
          title: "快捷入口",
          slot: "name",
          key: "name",
          align: "center"
        },
        {
          title: "内容描述",
          slot: "description",
          key: "description",
          align: "center"
        },
        {
          title: "按钮名称",
          slot: "linkName",
          key: "linkName",
          align: "center"
        },
        {
          title: "跳转链接",
          slot: "link",
          key: "link",
          align: "center"
        },
        {
          title: "显示顺序",
          slot: "showIndex",
          key: "showIndex",
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          align: "center"
        }
      ],
      list: [],
      modelTitle: "",
      options: {},
    };
  },
  methods: {
    ...mapActions({
      getCommonEntrance: "hostCommonModule/getCommonEntrance",
      delEntrance: "hostCommonModule/delEntrance"
    }),
    async init() {
      let list = await this.getCommonEntrance();
      if (list && list.length > 0) {
        this.list = list;
      }
      console.log(this.list);
    },
    add() {
      this.showModel = true;
      this.modelTitle = "添加快捷入口";
      this.options = {
        msg: null,
        model: null
      };
    },
    editModal(item) {
      this.showModel = true;
      this.modelTitle = "编辑展会";
      this.options = {
        msg: item,
        model: "edit"
      };
    },
    async delItem(item) {
      let bool = await this.delEntrance(item.id);
      if (bool && bool.successed) {
        this.$Message.success("删除成功！");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    }
  },
  created() {
    this.init();
  },
  components: {
    commonEntranceAdd
  }
};
</script>

<style lang="scss" scoped>
.common-home-entrance {
  .content {
    margin: 30px;
  }
}
</style>